import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class HomeSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            fade: false,
            cellSelector: '.homepage-slider__slide',
            imagesLoaded: true,
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.homepage-slider__slide');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default HomeSlider;